import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import { toast } from 'react-toastify';

const ContactModal = ({ open, onClose, contact, onSave }) => {
  const [formData, setFormData] = useState({
    name: '',
    number: '',
    email: '',
    profilePicUrl: '',
    isGroup: false
  });

  useEffect(() => {
    if (contact) {
      setFormData({
        name: contact.name || '',
        number: contact.number || '',
        email: contact.email || '',
        profilePicUrl: contact.profilePicUrl || '',
        isGroup: contact.isGroup || false
      });
    } else {
      setFormData({
        name: '',
        number: '',
        email: '',
        profilePicUrl: '',
        isGroup: false
      });
    }
  }, [contact]);

  const handleChange = (field) => (event) => {
    setFormData(prev => ({
      ...prev,
      [field]: event.target.value
    }));
  };

  const handleSubmit = async () => {
    try {
      if (!formData.name.trim()) {
        toast.error('Nome é obrigatório');
        return;
      }

      if (!formData.number.trim()) {
        toast.error('Número é obrigatório');
        return;
      }

      await onSave(formData);
      onClose();
    } catch (error) {
      console.error('Erro ao salvar contato:', error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {contact ? 'Editar Contato' : 'Novo Contato'}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Nome"
              value={formData.name}
              onChange={handleChange('name')}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Número"
              value={formData.number}
              onChange={handleChange('number')}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Email"
              type="email"
              value={formData.email}
              onChange={handleChange('email')}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="URL da Foto"
              value={formData.profilePicUrl}
              onChange={handleChange('profilePicUrl')}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Tipo</InputLabel>
              <Select
                value={formData.isGroup}
                onChange={handleChange('isGroup')}
                label="Tipo"
              >
                <MenuItem value={false}>Contato Individual</MenuItem>
                <MenuItem value={true}>Grupo</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleSubmit} variant="contained">
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactModal;